import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./components/About";
import HowToUse from "./components/HowToUse";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="flex bg-gray-100 min-h-screen">
        <Navbar />
        <div className="flex-grow p-6 flex justify-center items-center">
          <Routes>
            <Route exact path="/" element={<About />} />
            <Route path="/how-to-use" element={<HowToUse />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
